/**
 * cache
 * change logs:
 * 2017/11/24 herbluo created
 */
import LRU from 'lru-cache'

const options = {
  max: 500,
  length (n) {
    if (n instanceof Array) {
      return n.length
    }
    return 1
  },
  maxAge: 1000 * 60 * 60,
  stale: true // 超时首读可读
}

const lruCache = LRU(options)

export function Cacheable (second, thisBinding) {
  const maxAge = second ? (second * 1000) : undefined

  return (target, property, descriptor) => {
    const oldFunc = descriptor.value
    descriptor.value = (...args) => {
      const key =
        `${target.constructor.name}:${property}:${JSON.stringify(args)}`

      const cachedVal = lruCache.get(key)
      if (cachedVal) {
        return cachedVal
      }

      const result = oldFunc.apply(thisBinding || target, args)
      lruCache.set(key, result, maxAge)
      return result
    }
  }
}



// WEBPACK FOOTER //
// ./src/utils/cache.js